/** @jsxRuntime classic */
/** @jsx jsx */
// @ts-check
import { Link, Text } from '@bottlebooks/gatsby-theme-base';
import { graphql, useStaticQuery } from 'gatsby';
import { jsx } from 'theme-ui';
import useLink from '../../../../useLink';
import { gql } from 'urql';
import usePreviewData from '../../../../usePreviewData';

export default function TicketButton({ ...rest }) {
  const cmsLink = useLink();
  const result = useStaticQuery(query);
  const collectionId = result?.collection?.collectionId;
  const sites = result?.allSanitySite?.nodes;
  const cmsSite = sites?.find((site) => site.collectionId === collectionId);
  // We want to use preview data if available
  // At the moment, we are only loading published data, not draft data
  const [previewData] = usePreviewData();
  const site = previewData?.data?.allSite?.[0] || cmsSite;

  if (!site?.registrationPage) return null;
  const { registrationPage } = site;
  const url = cmsLink.page(registrationPage.page) || '';
  const link = {
    ...(url?.indexOf('http') > -1 ? { href: url } : { to: url }),
  };

  return (
    <Link
      variant="text"
      {...link}
      sx={{
        display: ['none', 'inline-block'],
      }}
      {...rest}
    >
      <Text variant="small">{registrationPage.name}</Text>
    </Link>
  );
}

const query = graphql`
  {
    collection: event {
      collectionId: eventId
    }
    allSanitySite {
      nodes {
        collectionId
        registrationPage {
          name
          page {
            __typename
            ... on SanityPage {
              slug {
                current
              }
            }
            ... on SanityExternalPage {
              title
              type
              url
            }
          }
        }
      }
    }
  }
`;

export const TicketButtonFragment = gql`
  fragment TicketButtonFragment on Site {
    collectionId
    registrationPage {
      name
      page {
        __typename
        ... on Page {
          id: _id
          slug {
            current
          }
        }
        ... on ExternalPage {
          title
          type
          url
        }
      }
    }
  }
`;
